import { render, staticRenderFns } from "./logList.vue?vue&type=template&id=65f73047&scoped=true"
import script from "./logList.vue?vue&type=script&lang=js"
export * from "./logList.vue?vue&type=script&lang=js"
import style0 from "./logList.vue?vue&type=style&index=0&id=65f73047&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f73047",
  null
  
)

export default component.exports